import {Component, Event, EventEmitter, h, Host, Prop, State} from '@stencil/core';

import "@bun-ui/icons";
import "@bun-ui/layout";
import "@bun-ui/links";

@Component({
  tag: 'lb-accounttype-mismatch',
  styleUrl: "styles.scss",
  shadow: true,
})
export class AccountTypeMismatch {

  /**
   * User Account Type buerger or organisation
   */
  @Prop({reflect: true}) userKontentyp: 'buerger' | 'organisation';

  /**
   * Form Type buerger or organisation
   */
  @Prop({reflect: true}) formularTyp: 'buerger' | 'organisation' | 'hybrid';

  // "meta" texts in selected language
  @Prop({ mutable: true }) i18n;

  @Prop() kontoAccountMenuActive;

  /**
   * message
   */
  @State() message: string;
  @State() error: boolean;

  @Prop({mutable: true}) account;

  @Event() logoutAndRetry: EventEmitter<any>;

  handleRelogin() {
    this.logoutAndRetry.emit();
  }

  componentDidLoad() {
    this.account = this.formularTyp === 'hybrid' ? this.userKontentyp : this.formularTyp;
  }

  render() {
    return (
      <Host>
        <div>
          <c-text data-testid="vorschalt-accounttype-mismatch-text">
            { (this.account === 'organisation') ? this.i18n?.beantragung?.accountTypeMismatchOrganisationText : this.i18n?.beantragung?.accountTypeMismatchBuergerText }
          </c-text>
          <br/>
          <br/>
          <div class="controls">
            <c-button data-testid="vorschalt-accounttype-mismatch-deny-logout-btn" large centered-content
              onClick={() => {
                window.history.back();
              }}>
              { this.i18n?.beantragung?.accountTypeMismatchDenyLogoutBtn }
            </c-button>

            <c-button data-testid="vorschalt-accounttype-mismatch-logout-btn" primary large centered-content
              onClick={() => {
                this.handleRelogin();
              }}>
              { this.i18n?.beantragung?.accountTypeMismatchLogoutBtn }
            </c-button>
          </div>
        </div>
        <c-modal flash visible={this.error} containerstyle="error" onClose={() => this.error = false}>
            <div slot="content">
                <c-header type="h2" role="heading" data-testid="vorschalt-accounttype-mismatch-logout-error">
                  {this.i18n?.error?.errorLogoutHeadline}
                </c-header>
                <c-text small data-testid="vorschalt-accounttype-mismatch-logout-error-text">
                  {this.i18n?.error?.errorLogoutText}
                </c-text>
            </div>
        </c-modal>
      </Host>
    );
  }
}